import {DetailedProject, ProjectType} from "../../../api-client";

export const isSocialProject = (project: DetailedProject): boolean => project.type === ProjectType.SOCIAL;

export const isProjectLoan = (project: DetailedProject): boolean => project.type === ProjectType.PROJECT;

export const getProjectGalleryImages = (project: DetailedProject): Array<string> => project.images ?? [];

export const getProjectVideoUrl = (project: DetailedProject): string | null | undefined => (
  project.videoPresentationUrl
);
